import { createActions } from 'redux-actions';

export const {
  analytics: {
    loadAnalytics, analyticsLoaded, track, pageView,
  },
}: any = createActions({
  ANALYTICS: {
    LOAD_ANALYTICS: () => ({
      isFetching: true,
    }),
    ANALYTICS_LOADED: () => ({
      isFetching: false,
    }),
    TRACK: (eventName: string, eventData: object) => ({
      eventName,
      eventData,
    }),
    PAGE_VIEW: (path: string, eventData: object) => ({
      path,
      eventData,
    }),
  },
});
